import { useEffect, useRef } from 'react';
import { GOOGLE_CLIENT_ID } from './../../../../../../shared/constants';
import { useLogin } from './../hooks/HookLogin';

export default function ButtonGoogle() { 
    
    const { handleGoogleSignInResponse , error} = useLogin();
    const googleButtonRef = useRef(null);

    // Volver a renderizar el botón cuando desaparece el error
    useEffect(() => {
        if (!error && googleButtonRef.current && window.google) {
            // Limpia el contenedor por si quedó algo renderizado previamente
            googleButtonRef.current.innerHTML = "";

            window.google.accounts.id.renderButton(googleButtonRef.current, {
                theme: "outline",
                size: "large",
            });
        }
    }, [error]);

    // Inicializar Google Auth una sola vez
    useEffect(() => {
        const renderGoogleButton = () => {
            if (!window.google || !googleButtonRef.current) return;

            window.google.accounts.id.initialize({
                client_id: GOOGLE_CLIENT_ID,
                callback: handleGoogleSignInResponse,
            });

            window.google.accounts.id.renderButton(googleButtonRef.current, {
                theme: "outline",
                size: "large",
            });

            window.google.accounts.id.prompt();
        };

        const timeout = setTimeout(renderGoogleButton, 0);
        return () => clearTimeout(timeout);
    }, []);

    return (
        <>
            <div
                ref={googleButtonRef}
                style={{ marginBottom: "2vh", display: "flex", justifyContent: "center", pointerEvents: error ? "none" : "auto", }}
            />
        </>
    );
}
